<template>
  <b-modal ref="modal" centered class="text-left">
    <div slot="modal-title">
      Manage cashflows
    </div>
    <b-row class="mb-2">
      <b-col>
        <label class="file-select">
          <div class="btn btn-info">
            <!-- Display the filename if a file has been selected. -->
            <span>Load from XLSX</span>
          </div>
          <input id="xlsx_select" type="file" multiple @change="handleFileChange"/>
        </label>
      </b-col>
    </b-row>
    <table class="table table-sm color">
      <thead>
        <th>Cashflow Name</th>
      </thead>
      <tbody>
        <tr v-for="(cashflow, index) of cashflows" :key="index">
          <td>{{cashflow.text}}</td>
          <td>
            <b-btn variant="link" @click="deleteCashflow(index)">Delete</b-btn>
          </td>
        </tr>
      </tbody>
    </table>
    <div slot="modal-footer" />
  </b-modal>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  props: {
    cashflows: Array
  },
  data() {
    return {
      fileName: ''
    };
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    deleteCashflow(index) {
      let cashflows = this.cashflows;
      cashflows.splice(index, 1);
      this.$emit('deleteCashflow', cashflows);
      // this.$refs.modal.hide();
    },
    handleFileChange(e) {
      const reader = new FileReader();
      try {
        this.readFiles(reader, e, 0);
      } catch (err) {
        this.$emit('error', err);
      } finally {
        this.$refs.modal.hide();
      }
    },
    readFiles(reader, e, i) {
      if (i < e.target.files.length) {
        let file = e.target.files[i];
        reader.onloadend = loadEvent => {
          const bstr = loadEvent.target.result;
          const wb = XLSX.read(bstr, { type: 'binary' });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          this.$emit('loadCashflow', file.name, data);
          this.readFiles(reader, e, i + 1);
        };
        reader.readAsBinaryString(file);
      } else {
        this.$refs.modal.hide();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.file-select {
  > .select-button {
    padding: 1rem;

    color: white;
    background-color: #2ea169;

    border-radius: 0.3rem;

    text-align: center;
    font-weight: bold;
  }
}

#xlsx_select {
  display: none;
}
</style>
